export const DEFAULT_TARGET_REQUESTS_PER_MINUTE = 600;

export const resolveTargetRequestsPerMinute = (
  value?: number | null,
): number => (value == null ? DEFAULT_TARGET_REQUESTS_PER_MINUTE : value);
